import Waves from './Waves';

export default Waves;
